<mat-form-field style="width: 100px">
    <mat-label>Tipo de dirección</mat-label>
    <mat-select [formControl]="control('tipoDireccion')" disabled>
        <mat-option [value]="dirEnvio">Envío</mat-option>
        <mat-option [value]="dirFact">Facturación</mat-option>
    </mat-select>
</mat-form-field>
<mat-form-field style="width: 80%">
    <mat-label>Calle</mat-label>
    <input [formControl]="control('calle')" matInput>
    <mat-error *ngIf="control('calle').hasError('invalid')">La
        dirección debe tener contenido.
    </mat-error>
</mat-form-field>
<mat-form-field>
    <mat-label>Código Postal</mat-label>
    <input [formControl]="control('cp')" matInput>
    <mat-error *ngIf="control('cp').hasError('invalid')">Código postal
        inválido.
    </mat-error>
</mat-form-field>
<mat-form-field style="width: 20%">
    <mat-label>Población</mat-label>
    <input [formControl]="control('poblacion')" matInput>
    <mat-error *ngIf="control('poblacion').hasError('invalid')">La
        población debe tener contenido.
    </mat-error>
</mat-form-field>
<mat-form-field style="width: 20%">
    <mat-label>Provincia</mat-label>
    <input [formControl]="control('demarcacion')"
           [matAutocomplete]="auto"
           matInput placeholder="Empiece a escribir la provincia..." type="text">
    <mat-autocomplete #auto autoActiveFirstOption [displayWith]="displayProperty">
        <mat-option *ngFor="let provincia of filteredProvincias | async"
                    [value]="provincia">{{ provincia.nombre }}
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="control('demarcacion').hasError('invalid')">La
        provincia debe tener contenido.
    </mat-error>
</mat-form-field>
<mat-form-field style="width: 20%">
    <mat-label>Pais</mat-label>
    <input [formControl]="control('pais')" [matAutocomplete]="auto2"
           matInput placeholder="Empiece a escribir el país..." type="text">
    <mat-autocomplete #auto2 autoActiveFirstOption
                      [displayWith]="displayProperty">
        <mat-option *ngFor="let pais of filteredPaises | async"
                    [value]="pais">{{ pais.nombreDefault }}
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="control('pais').hasError('invalid')">El país
        debe
        ser escogido de la lista.
    </mat-error>
</mat-form-field>
